(async () => {
  const SCOPE_VISIT = 2;
  const SCOPE_PAGE = 3;
  let script_is_put = false;

  const send_event = (...args) => {
    window._uxa = window._uxa || [];
    window._uxa.push([...args]);
  };

  //Initialize GTM tag
  async function launchTag(fake_page) {
    const { pathname } = init?.context?.document?.location || {};

    const pagePath = pathname.replace(/\/checkouts\/cn\/.*$/, "/checkouts/");

    let put_tag = false;

    const { analyticsProcessingAllowed } = init?.customerPrivacy || {};

    if (analyticsProcessingAllowed) {
      put_tag = true;
    } else {
      console.log("Contensquare not thrown because of consent");
    }

    if (!script_is_put && put_tag) {
      const contentsquare_tag_id = await browser.cookie.get(
        "contentsquare_tag_id"
      );

      send_event("setPath", pagePath);
      const mt = document.createElement("script");
      mt.type = "text/javascript";
      mt.async = true;
      mt.src = `//t.contentsquare.net/uxa/${contentsquare_tag_id}.js`;
      document.getElementsByTagName("head")[0].appendChild(mt);
      script_is_put = true;
    } else if (fake_page) {
      send_event(
        "trackPageview",
        pathname.replace(/\/[^\/]+$/, `/${fake_page}`)
      );
    }
  }

  // Étape 1. Initialisez le SDK du pixel JavaScript (pensez à exclure le code HTML)

  const getCheckoutItems = (items) => {
    return items
      .map((item, index) => {
        const { variant } = item;
        const { id } = variant;
        return id;
      })
      .join("|");
  };

  const send_general_infos = () => {
    const { ordersCount = 0 } = init?.data?.customer || {};
    const { cost = 0 } = init?.data?.cart || {};

    send_event(
      "setCustomVariable",
      3,
      "user_newCustomer",
      (ordersCount === 0).toString(),
      SCOPE_VISIT
    );

    send_event(
      "setCustomVariable",
      5,
      "user_numberOfOrders",
      ordersCount.toString(),
      SCOPE_VISIT
    );

    send_event(
      "setCustomVariable",
      14,
      "env_currency",
      init?.data?.shop?.paymentSettings?.currencyCode,
      SCOPE_PAGE
    );
  };

  // only for checkout extensibility or non shopify + sites
  analytics.subscribe("checkout_started", async (event) => {
    send_general_infos();
    send_event(
      "setCustomVariable",
      11,
      "page_type",
      "begin_checkout",
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      16,
      "basket_items",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      17,
      "basket_amount",
      event.data.checkout.subtotalPrice.amount.toString(),
      SCOPE_PAGE
    );

    await launchTag();
  });

  analytics.subscribe("checkout_completed", async (event) => {
    send_general_infos();
    send_event("setCustomVariable", 11, "page_type", "purchase", SCOPE_PAGE);

    send_event(
      "setCustomVariable",
      13,
      "env_country",
      event.data.checkout.shippingAddress.countryCode,
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      18,
      "order_products",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_VISIT
    );

    send_event(
      "setCustomVariable",
      16,
      "basket_items",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      17,
      "basket_amount",
      event.data.checkout.subtotalPrice.amount.toString(),
      SCOPE_PAGE
    );

    send_event("ec:transaction:create", {
      id: event.data.checkout.order.id.toString(),
      revenue: event.data.checkout.subtotalPrice.amount.toString(),
      currency: event.data.checkout.currencyCode,
    });

    send_event("ec:transaction:send");

    await launchTag("purchase");
  });

  analytics.subscribe("payment_info_submitted", async (event) => {
    send_general_infos();

    send_event(
      "setCustomVariable",
      11,
      "page_type",
      "add_payment_info",
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      13,
      "env_country",
      event.data.checkout.shippingAddress.countryCode,
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      16,
      "basket_items",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      17,
      "basket_amount",
      event.data.checkout.subtotalPrice.amount.toString(),
      SCOPE_PAGE
    );

    await launchTag("add_payment_info");
  });

  analytics.subscribe("checkout_shipping_info_submitted", async (event) => {
    send_general_infos();

    send_event(
      "setCustomVariable",
      11,
      "page_type",
      "add_shipping_info",
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      13,
      "env_country",
      event.data.checkout.shippingAddress.countryCode,
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      16,
      "basket_items",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      17,
      "basket_amount",
      event.data.checkout.subtotalPrice.amount.toString(),
      SCOPE_PAGE
    );

    await launchTag("add_shipping_info");
  });

  analytics.subscribe("checkout_address_info_submitted", async (event) => {
    send_general_infos();

    send_event(
      "setCustomVariable",
      11,
      "page_type",
      "checkout_address_info_submitted",
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      13,
      "env_country",
      event.data.checkout.shippingAddress.countryCode,
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      16,
      "basket_items",
      getCheckoutItems(event.data.checkout.lineItems),
      SCOPE_PAGE
    );

    send_event(
      "setCustomVariable",
      17,
      "basket_amount",
      event.data.checkout.subtotalPrice.amount.toString(),
      SCOPE_PAGE
    );

    await launchTag("checkout_address_info_submitted");
  });
})();
